import { z } from "zod";

export const completeOnboardingSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  location: z.string().min(1, "Location is required"),
  city: z.string().min(1, "City is required"),
  state: z.string().min(1, "State is required"),
  serpApiData: z
    .array(
      z.object({
        placeId: z.string().optional(),
        name: z.string().optional(),
        address: z.string().optional(),
        website: z.string().optional(),
      })
    )
    .default([]),
  companyPlaceId: z.string().optional(),
  websiteUrl: z.string().optional(),
  industry: z.string().min(1, "Industry is required"),
  userProvidedTeamMemberCount: z.number().optional().default(1),
  annualRevenue: z.string().optional(),
  yearsInBusiness: z.string().optional(),
  reboltGoals: z.array(z.string()).default([]),
  otherGoals: z.string().optional(),
  reboltOrganizationId: z.string().optional(),
  reboltWebsiteId: z.string().optional(),
});

export type CompleteOnboardingFormData = z.infer<typeof completeOnboardingSchema>;
